/* eslint-disable */
import React, { useCallback, useEffect, useState, useRef } from 'react';
import './index.scss'
// import { Popup } from 'antd-mobile-v5'
import LivePlayer from '../livePlayer'
// import VideoPlayer from '../videoPlayer'
import { debounce } from 'lodash-es';
// import mpegts from 'mpegts.js';

const LiveList = (props) => {
    const { data: { playbackList, liveList }, pageCount, contentRef } = props
    const [showReplayTodo, setShowReplayTodo] = useState(false)
    // 视频播放相关
    // const [videoPopShow, setVideoPopShow] = useState(false)
    // const [popVideoInfo, setPopVideoInfo] = useState({})
    const livePlayerInfo = useRef({})
    const latestScrolltop = useRef(0)


    useEffect(() => {
        if (playbackList && playbackList.length % 2 != 0) {
            setShowReplayTodo(true)
        }
    }, [playbackList])

    useEffect(() => {
        if (!contentRef) {
            return
        }
        const el = contentRef.current
        el.addEventListener('scroll', debounce(handleContentScroll, 100))
        return () => {
            el.removeEventListener('scroll', (e) => {
                document.body.style.overflow = 'auto'
            })
        }
    }, [contentRef])

    const handleContentScroll = (e) => {
        const scrollTop = e.target?.scrollTop
        // 最开始定义是多个直播间，才会考虑循环
        if (livePlayerInfo.current && Object.keys(livePlayerInfo.current).length > 0) {
            const
                sTop = e.target.getBoundingClientRect().top,
                sHeight = e.target.getBoundingClientRect().height
            // 临界值滚动区域中心位置
            const center = (sHeight / 2) + sTop;
            // 目标元素在滚动区域一半的高度
            liveList.map((item) => {
                const player = livePlayerInfo.current[item.liveId];
                // 在播放中处理事件
                if (player && !player.current.paused) {
                    // 如果在可视区域内 并且是直播中的状态
                    let videoEle;
                    // android player flv 播放器
                    // ios 差异 m3u8 播放器
                    if (player.current?.parentElement) {
                        videoEle = player.current
                    } else {
                        videoEle = player.current?._mediaElement
                    }
                    // 
                    if (!videoEle?.parentElement) {
                        return
                    }
                    const { top, bottom } = videoEle?.parentElement?.getBoundingClientRect()
                    // 向下滚动判断元素 上边框小于中心位置
                    if ((latestScrolltop.current < scrollTop && (bottom + 30) < center)
                        || (latestScrolltop.current > scrollTop && (top - 30) > center)) {
                        player.current.pause()
                    }
                }
            })
        }
        latestScrolltop.current = scrollTop
    }

    const replayVideoFn = (info) => {
        if (typeof props.onItemClick != 'undefined') {
            props.onItemClick({
                wbmainUrl: info?.wbmainUrl,
                url: info.url
            })
        }
        // 显示视频播放弹窗
        // const { pic: poster, video: mp4Url } = info
        // if (mp4Url) {
        //     setVideoPopShow(true);
        //     if (popVideoInfo.src != mp4Url) {
        //         setPopVideoInfo({
        //             src: mp4Url,
        //             poster
        //         });
        //     }
        // }
    }

    useEffect(() => {
        // console.log('livePlayerInfo 变更了')
    }, [livePlayerInfo])

    const onLiveplayerReady = (liveId, player) => {
        // livePlayerInfo.current = player;
        if (typeof livePlayerInfo.current[liveId] == "undefined") {
            livePlayerInfo.current[liveId] = player;
        }
    }

    return (
        <div>
            <div className='livelist'>
                {liveList && liveList.length > 0 &&
                    liveList.map((item, index) => {
                        return (
                            <div className='liveroom' key={`room-${index}`}>
                                <LivePlayer
                                    className='liveplayer'
                                    width={'558px'}
                                    height={'632px'}
                                    // onPlayClick={() => { onLivePlayerClick(item) }}
                                    onLivePlayerReady={(player) => { onLiveplayerReady(item.liveId, player) }}
                                    liveId={item.liveId}
                                    liveStatus={item.status}
                                    // liveSource={liveSource}
                                    title={item.title}
                                    poster={item.coverPic}></LivePlayer>
                                <div className='liveroom-title'>{item.title}</div>
                            </div>
                        )
                    })}
            </div>
            <div className='replaylist'>
                {
                    playbackList && playbackList.map((item, index) => {
                        return (
                            <div className='replaylist-item' key={`item-${index}`} onClick={() => { replayVideoFn(item) }}>
                                <img className='cover' src={item.pic} />
                                <div className='title textEllipsis'>{item.title}</div>
                                <div className='iconRpelay'>回放</div>
                            </div>
                        )
                    })
                }
                {
                    showReplayTodo && <div className='replaylist-item'>
                        <img className='expect-wrap' src='//icon.xgo-img.com.cn/mtouch/24041215/expectTag.png' />
                    </div>
                }
            </div>
            {/* {videoPopShow &&
                <VideoPlayer
                    {...popVideoInfo}></VideoPlayer>
            } */}
        </div>
    )
}
export default LiveList;
